import {
  CustomCollapseCard,
  CustomImage,
  CustomPagination,
  CustomTable,
  Text,
} from '@src/components';
import iconUser from '@src/assets/icons/icon-profil-user.svg';
import { useDispatch, useSelector } from 'react-redux';
import { moneyFormat } from '@src/utils/utils';
import iconChecked from '@src/assets/icons/icon-checked.svg';
import iconNoChecked from '@src/assets/icons/icon-no-check.svg';
import { useCallback, useEffect } from 'react';
import { cardOrderDetailsGelAll } from '@src/store/slice/cardOrderDetailtsSlice';

const CardDetailInformation = () => {
  const { currentCardOrder } = useSelector((state) => state?.cardOrder);
  const { cardList, tableProperty } = useSelector((state) => state?.cardOrderDetails);
  const dispatch = useDispatch();

  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
      fixed: 'left',
      align: 'center',
      width: 70,
      render: (_, __, index) =>
        (tableProperty?.currentPage - 1) * tableProperty?.pageSize + index + 1,
    },
    {
      title: <Text t="nameUpperCase" />,
      dataIndex: 'name',
      key: 'name',
      width: 162.7,
    },
    {
      title: <Text t="surnameUpperCase" />,
      dataIndex: 'surname',
      key: 'surname',
      width: 162.7,
    },
    {
      title: <Text t="referenceNoUpperCase" />,
      dataIndex: 'refNo',
      key: 'refNo',
      width: 150,
      align: 'center',
    },
    {
      title: <Text t="gsmNoUpperCase" />,
      dataIndex: 'gsm',
      key: 'gsm',
      width: 150,
      align: 'center',
    },
    {
      title: <Text t="deliveryAddressUpperCase" />,
      width: 162.7,
      dataIndex: 'addressText',
      key: 'addressText',
      align: 'center',
    },
    {
      title: <Text t="mobilePayment" />,
      dataIndex: 'mobilePaymentAuthorization',
      key: 'mobilePaymentAuthorization',
      width: 110,
      align: 'center',
      render: (text) =>
        text ? (
          <CustomImage src={iconChecked} alt='check' />
        ) : (
          <CustomImage src={iconNoChecked} alt='uncheck' />
        ),
    },
    {
      title: <Text t="totalPrice" />,
      dataIndex: 'price',
      key: 'price',
      width: 150,
      align: 'right',
      render: (text) => <span>{text ? `${moneyFormat(text, false)}` : '0'}</span>,
    },
  ];

  useEffect(() => {
    (async () => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber: 1, pageSize: 10 }));
    })();
  }, [dispatch]);

  const handleTableChange = useCallback(
    async (pageNumber, pageSize) => {
      await dispatch(cardOrderDetailsGelAll({ pageNumber, pageSize }));
    },
    [dispatch],
  );

  return (
    <CustomCollapseCard cardTitle={<Text t="cardInformation" />}>
      <div className="card-information">
        <CustomImage src={iconUser} />
        <div className="card-count-title">
          <Text t="numberOfCards3" />: <span>{currentCardOrder?.totalCount}</span>
        </div>
      </div>
      <CustomTable
        pagination={false}
        dataSource={cardList}
        columns={columns}
        rowKey={(record) => `card-summary-detail-list-${record?.id || record?.name}`}
      />
      <div className="card-information-footer">
        <CustomPagination
          current={tableProperty?.currentPage}
          defaultCurrent={1}
          pageSize={tableProperty?.pageSize}
          total={tableProperty?.totalCount}
          onChange={async (pageNumber, pageSize) => {
            await handleTableChange(pageNumber, pageSize);
          }}
        />
        <div className="total-amount-title">
          <Text t="totalBalanceToBeLoadedUpperCaseColon" />
          <span>{moneyFormat(currentCardOrder?.totalPrice, true)}</span>
        </div>
      </div>
    </CustomCollapseCard>
  );
};

export default CardDetailInformation;
